import React from 'react';
import { inject, observer } from 'mobx-react';

import Msg from '@/components/Msg';
import { getContent } from '@/utils/tools';
import { tracker } from '@/utils/tracking';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { handleLoginBtnClick } from '@/utils/btnClickHandler';
import { TRACKING_MSG_TYPE, TRACKING_TYPE } from '@/utils/constants';
import SingleButton, { getClassName, getDisabledClassName } from '@/components/SingleButton';

const PREFIX = 'login-container';

@tracker
@inject(getChildInject('initStore'))
@observer
export default class Login extends React.PureComponent {
  static defaultProps = {
    // props
    msgContent: '',
    button: {},
    dialogueId: '',
    dialogueType: '',
    isDisabled: false,
    req: {},
    // stores
    initStore: {},
  };

  constructor(props) {
    super(props);
    const {
      button,
      dialogueId,
      initStore,
      nodePointId,
      isHistory,
      historyDialogueId,
      historySessionId,
    } = this.props;
    const { button_type, button_id } = button;

    this.trackingname = TRACKING_TYPE.STANDARDIZE_BUTTON;
    this.trackingdata = {
      node_point_id: nodePointId,
      chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      button_details: [{
        button_text: getContent(button),
        button_type,
        button_id,
      }],
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    };
  }

  handleJumpClick = () => {
    const {
      dialogueId,
      dialogueType,
      req,
      isHistory,
    } = this.props;

    handleLoginBtnClick({
      dialogueId,
      dialogueType,
      req,
      isHistory,
    }, {
      trackingname: this.trackingname,
      trackingdata: this.getTrackingData(),
    });
  };

  // 埋点用 - 点击事件
  getTrackingData = () => {
    const {
      nodePointId, initStore, dialogueId, button, isHistory,
      historyDialogueId, historySessionId,
    } = this.props;
    const { button_type, button_id } = button;

    return {
      node_point_id: nodePointId,
      chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      button_text: getContent(button),
      button_type,
      button_id,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    };
  };

  render() {
    const {
      msgContent,
      button,
      isDisabled,
      disabledBtn,
      passedRef,
    } = this.props;
    const trackingdata = JSON.stringify(this.trackingdata);
    const className = disabledBtn ? getDisabledClassName(button.style) : getClassName(button.style);

    return <div className={PREFIX}>
      <Msg content={msgContent} />
      {
        isDisabled
          ? null
          : <SingleButton
            disabled={disabledBtn}
            passedRef={passedRef}
            trackingname={this.trackingname}
            trackingdata={trackingdata}
            text={getContent(button)}
            handleClick={this.handleJumpClick}
            className={className}
          />
      }
    </div>;
  }
}
